import './team-leden.scss';
import { gsap } from 'gsap';

/**
 * Team leden — hover badge follower.
 * Badge follows the cursor within each portrait image.
 * Scoped to [data-component="team-leden"]; supports multiple instances per page.
 */
function initTeamLeden() {
	const roots = document.querySelectorAll( '[data-component="team-leden"]' );

	if ( ! roots.length ) {
		return;
	}

	roots.forEach( ( root ) => {
		let mouseX = 0;
		let mouseY = 0;

		const tickCallbacks = [];

		function onMouseMove( e ) {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		window.addEventListener( 'mousemove', onMouseMove );

		const cards = root.querySelectorAll( '.b-teamLeden__card' );

		cards.forEach( ( card ) => {
			const imageContainer = card.querySelector( '[data-team-image]' );
			const badge = card.querySelector( '[data-team-badge]' );

			if ( ! imageContainer || ! badge ) {
				return;
			}

			gsap.set( badge, { x: 0, y: 0, autoAlpha: 0, clipPath: 'inset(0 50% 0 50%)' } );

			const xTo = gsap.quickTo( badge, 'x', { duration: 0.6, ease: 'power3.out' } );
			const yTo = gsap.quickTo( badge, 'y', { duration: 0.6, ease: 'power3.out' } );

			let isHovered = false;

			function tick() {
				if ( ! isHovered ) {
					return;
				}
				const rect = imageContainer.getBoundingClientRect();
				xTo( mouseX - rect.left - badge.offsetWidth / 2 );
				yTo( mouseY - rect.top + 20 );
			}

			tickCallbacks.push( tick );

			imageContainer.addEventListener( 'mouseenter', () => {
				isHovered = true;
				gsap.ticker.add( tick );

				const rect = imageContainer.getBoundingClientRect();
				gsap.set( badge, {
					x: mouseX - rect.left - badge.offsetWidth / 2,
					y: mouseY - rect.top + 20,
				} );
				gsap.to( badge, {
					autoAlpha: 1,
					clipPath: 'inset(0 0% 0 0%)',
					duration: 0.4,
					ease: 'power3.out',
					overwrite: 'auto',
				} );
			} );

			imageContainer.addEventListener( 'mouseleave', () => {
				isHovered = false;
				gsap.ticker.remove( tick );
				gsap.to( badge, {
					autoAlpha: 0,
					clipPath: 'inset(0 50% 0 50%)',
					duration: 0.3,
					ease: 'power3.in',
					overwrite: 'auto',
				} );
			} );
		} );

		root._teamLedenCleanup = () => {
			window.removeEventListener( 'mousemove', onMouseMove );
			tickCallbacks.forEach( ( cb ) => gsap.ticker.remove( cb ) );
		};
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initTeamLeden );
} else {
	initTeamLeden();
}
